import axios from "axios";
import { toast } from "../components/Toast";

/**
 * Cliente sem interceptors — só para refresh e bootstrap silencioso de /me.
 */
export const bareApi = axios.create({ baseURL: "/api", withCredentials: true });

let isRefreshing = false;
/** @type {{ resolve: function, reject: function, client: import("axios").AxiosInstance, config: object }[]} */
let pending = [];
let forcingLogout = false;

function redirectToLogin() {
  window.location.href = "/login";
}

function shouldSkip401Refresh(url) {
  const u = String(url || "");
  return (
    u.includes("/auth/refresh") ||
    u.includes("/auth/login") ||
    u.includes("/auth/logout")
  );
}

function handleSessionExpired() {
  if (forcingLogout) return;
  forcingLogout = true;
  bareApi.post("/auth/logout", {}).catch(() => {});
  toast("Sessão expirada. Faça login novamente.", "error");
  redirectToLogin();
}

function attach401Interceptor(client) {
  client.interceptors.response.use(
    (res) => res,
    async (error) => {
      const original = error.config || {};
      const url = original.url || "";

      if (error.response?.status === 401 && !original._retry) {
        if (shouldSkip401Refresh(url)) {
          return Promise.reject(error);
        }

        original._retry = true;

        if (!isRefreshing) {
          isRefreshing = true;
          try {
            await bareApi.post("/auth/refresh", {});
            const queue = pending;
            pending = [];
            queue.forEach(({ resolve, reject, client: c, config }) => {
              c(config).then(resolve).catch(reject);
            });
            return client(original);
          } catch {
            const queue = pending;
            pending = [];
            queue.forEach(({ reject }) => reject(error));
            handleSessionExpired();
            return Promise.reject(error);
          } finally {
            isRefreshing = false;
          }
        }

        return new Promise((resolve, reject) => {
          pending.push({ resolve, reject, client, config: original });
        });
      }

      if (error.response?.status === 401 && !forcingLogout) {
        handleSessionExpired();
      }

      return Promise.reject(error);
    }
  );
}

/** Rotas /api (auth, etc.) */
export const authApi = axios.create({ baseURL: "/api", withCredentials: true });
attach401Interceptor(authApi);

/** Rotas /api/church — export default mantém compat com `import api from "../services/api"` */
export const churchApi = axios.create({ baseURL: "/api/church", withCredentials: true });
attach401Interceptor(churchApi);

export function resetSessionFlags() {
  forcingLogout = false;
}
